import {Service} from '@s-ui/domain'
import {toQueryString} from '@s-ui/js/lib/string'

export default class GetLoginUrlWithQueryParamsService extends Service {
  constructor({config, getUrlService}) {
    super({config})
    this._config = config
    this._targetPageQueryParam = this._config.get('QUERY_PARAM_TARGET_PAGE')
    this._getUrlService = getUrlService
  }

  /**
   * @param {Object} params
   * @param {Object} data.queryParams
   * @return {String} queryParams
   */
  _getQueryParams({queryParams}) {
    return toQueryString(queryParams)
  }

  /**
   * @param {Object} params
   * @param {String} params.url
   * @param {Object} params.queryParams
   * @return {Promise<Object, Error>} url
   */
  async execute({url, queryParams}) {
    const {QUESTION_MARK, AMPERSAND_MARK} = this._config.get('page')
    const hasQueryStringsOnUrl = url.includes(QUESTION_MARK)
    const joiner = hasQueryStringsOnUrl ? AMPERSAND_MARK : QUESTION_MARK
    const targetPage = `${url}${joiner}${this._getQueryParams({queryParams})}`

    return this._getUrlService.execute({pageName: 'LOGIN', query: {targetPage}})
  }
}
